import React from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/cartContext";

export default function BuyButton({ product, label = "Megveszem", testId, className = "btn-fire" }) {
  const { addItem } = useCart();

  return (
    <button
      type="button"
      data-testid={testId || `buy-${product.id}`}
      onClick={() => addItem(product)}
      className={className}
    >
      <ShoppingBag className="w-4 h-4" strokeWidth={1.8} />
      {label}
    </button>
  );
}
